// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2rsSC","container":"index-module--container--12zWd","title":"index-module--title--2wRBO","date":"index-module--date--1NWMg"};